import moment from 'moment';
import {ISchedule} from 'tui-calendar';

export interface MechanicBookingType {
    mechanicRestAvailability: moment.Duration;
    color: string;
    schedules: ISchedule[];
    end?: Date;
    mechanicId?: string | number;
    id: number;
    start: Date;
}

export enum MechanicBookingColors {
    green = '#4CAF50',
    red = '#F44336',
    orange = '#FF9800',
}

